import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import React from "react";
import { SnackbarProvider } from "notistack";
import SnackbarCloseButton from "splash_components/SnackbarCloseButton/SnackbarCloseButton";
import ContactSuccess from "splash_components/ContactSuccess/ContactSuccess";

export default function ContactSuccessRoot() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#004080",
      },
      secondary: {
        main: "#FFFFFF",
      },
    },
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4500}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
    >
      <ThemeProvider theme={theme}>
        <ContactSuccess />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
